import {  } from "helpers/url_helper";

import{
GET_CORALOGIX_SUBSYSTEMS,
GET_CORALOGIX_SUBSYSTEMS_FAIL,
GET_CORALOGIX_SUBSYSTEMS_SUCCESS,
POST_SUBSYSTEMS_SERVICE_MAPPING,
POST_SUBSYSTEMS_SERVICE_MAPPING_FAIL,
POST_SUBSYSTEMS_SERVICE_MAPPING_SUCCESS
} from "./actionTypes";

    export const getCoralogixSubsystems = () => ({
        type: GET_CORALOGIX_SUBSYSTEMS,
    });
    export const getCoralogixSubsystemsSuccess = (data) => ({
        type: GET_CORALOGIX_SUBSYSTEMS_SUCCESS,
        payload: data,
    });
    export const getCoralogixSubsystemsFail = error => ({
        type: GET_CORALOGIX_SUBSYSTEMS_FAIL,
        payload: error,
    });
    export const postSubsystemsServiceMapping = (service_mapping) => ({
        type: POST_SUBSYSTEMS_SERVICE_MAPPING,
        payload: { service_mapping }
    });
    export const postSubsystemsServiceMappingFail = error => ({
        type: POST_SUBSYSTEMS_SERVICE_MAPPING_FAIL,
        payload: error,
    });
    export const postSubsystemsServiceMappingSuccess = coralogix_subsystems => ({
        type: POST_SUBSYSTEMS_SERVICE_MAPPING_SUCCESS,
        payload: coralogix_subsystems,
    });
    